import React , { useContext, useState, useEffect } from 'react';
import { Image,  Button} from 'react-bootstrap';
import Container from 'react-bootstrap/Container';
import Navbar from 'react-bootstrap/Navbar';
import logo from '../../assets/cropped-Logo-RUSHTERS.png';
import { UserContext } from '../../UserContext';
import Form from 'react-bootstrap/Form';
import Nav from 'react-bootstrap/Nav';
import { useNavigate} from 'react-router-dom';
import  secureLocalStorage  from  "react-secure-storage";

const NavDefault = () => {
    const {user ,logout,loading,activeModule,setActiveModule} = useContext(UserContext);
    const [showUserSegments, setShowUserSegment] = useState(false);
    const [activeModuleSave, setActiveModuleSave] = useState("");



    const logout_user = () =>{ logout(); };
    const navigate= useNavigate();
    useEffect( () => {
        setShowUserSegment(user !== null);
    },[user]);

    useEffect( () => {
        const m = secureLocalStorage.getItem("activeModule");
        if(m){
            setActiveModuleSave(m);
        }else{
            setActiveModuleSave("2");
        }

    },[]);


    const chageModule = (module) => {

        secureLocalStorage.setItem("activeModule",module);
        setActiveModuleSave(module);
        if(module === "2") navigate(`/register`);
        if(module === "1") navigate(`/admin`);
    }

    return(
        <>
        <Navbar bg="dark"  expand="lg" className="bg-body-tertiary" data-bs-theme="dark">
            <Container fluid>
            <Navbar.Brand className=''  href="/">
                {showUserSegments && !loading && <Image className='img-responsive  ' src={logo} width={170}  />}
            </Navbar.Brand>
            <Navbar.Toggle aria-controls="basic-navbar-nav" />
            <Navbar.Collapse id="basic-navbar-nav">
                <Nav className="me-auto">
                    <Form inline="true">
                        <Form.Select value={activeModuleSave} onChange={ (e) => chageModule(e.target.value)  } >
                            <option   value="1">Módulo Administración</option>
                            <option   value="2">Módulo Registro</option>
                        </Form.Select>
                    </Form>
                </Nav>
            </Navbar.Collapse>
            <Navbar.Collapse className="justify-content-end">
                {showUserSegments &&  !loading  && <Navbar.Text>
                    Usuario {user?.displayName}<br/>
                    <Button  onClick={logout_user} variant='link' size='xs'>Cerrar sesión</Button>
                </Navbar.Text>}
            </Navbar.Collapse>

            </Container>
        </Navbar>
        </>
    )
}
export default NavDefault;